import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  Box,
  Typography
} from '@mui/material';

type Props = {
  open: boolean;
  title: string;
  hideActionButton?: boolean;
  isActionDisabled?: boolean;
  actionButtonText?: string;
  actionButtonType?: 'Success' | 'Danger';

  cancelButtonText?: string;

  onClose: () => void;
  onCancelClick: () => void;
  onActionClick?: () => void;

  children: React.ReactNode;
};

const CustomModal = ({
  open,
  title,
  hideActionButton = false,
  isActionDisabled,
  actionButtonText = 'Ok',
  actionButtonType,

  cancelButtonText = 'Cancel',
  onClose,
  onCancelClick,
  onActionClick,

  children
}: Props) => {
  return (
    <Dialog open={open} onClose={onClose} className="modal-container">
      <Box p={3} position="relative">
        <DialogTitle sx={{ padding: 0, marginBottom: 2 }}>
          <Typography fontSize={20} fontWeight={600} paddingBottom={'20px'}>
            {title}
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ padding: 0 }}>{children}</DialogContent>

        <DialogActions sx={{ padding: 0, paddingTop: 2 }}>
          <Button
            variant="text"
            onClick={onCancelClick}
            className="cancel-button"
          >
            {cancelButtonText}
          </Button>

          {!hideActionButton && (
            <Button
              variant="contained"
              onClick={onActionClick}
              disabled={isActionDisabled}
              className={
                actionButtonType === 'Danger'
                  ? 'danger-button btn'
                  : 'success-button btn'
              }
            >
              {actionButtonText}
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default CustomModal;
